<div class="page">
  <div class="content-box">
    <!-- Logo Section -->
    <section class="logo-container" @fadeInUp>
      <div class="logo">
        <img
          src="assets/imgs/psicogenius_with_border.png"
          alt="logo"
          class="img"
        />
      </div>
    </section>

    <!-- Main Dashboard Grid -->
    <div class="dashboard-grid" @cardAnimation>
      <!-- Calendar Section -->
      <section class="calendar-section" [style]="getCardAnimationDelay(0)">
        <div class="card-flip">
          <div
            class="card-front clickable"
            (click)="navigateToPage('/calendario')"
          >
            <div class="title-container">
              <img src="assets/imgs/icons/calendario.svg" alt="calendar" />
              <span>Calendario</span>
            </div>
            <div class="feature-list">
              <div class="feature-item">
                <img
                  src="assets/imgs/icons/calendar_days.svg"
                  alt="ai"
                  style="height: 30px"
                />
                <span>Appuntamenti</span>
              </div>
              <div class="feature-item">
                <img
                  src="assets/imgs/icons/user.svg"
                  alt="ai"
                  style="height: 30px"
                />
                <span>Prossimo Paziente</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Patients Section -->
      <section class="patients-section" [style]="getCardAnimationDelay(1)">
        <div class="card-flip">
          <div
            class="card-front clickable"
            (click)="navigateToPage('/pazienti')"
          >
            <div class="title-container">
              <img src="assets/imgs/icons/pazienti.svg" alt="patient" />
              <span>Pazienti</span>
            </div>
            <div class="feature-list">
              <div class="feature-row">
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/list_bullet.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Lista Pazienti</span>
                </div>
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/identification.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Anagrafica</span>
                </div>
              </div>
              <div class="feature-row">
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/document_text.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Dati Paziente</span>
                </div>

                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/arrow_long_right.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Linea di Vita</span>
                </div>
              </div>
              <div class="feature-row">
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/document.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Documenti Paziente</span>
                </div>
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/sparkles.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Funzioni AI</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Documents Container -->
      <section
        class="documents-container"
        [style]="getCardAnimationDelay(2)"
        (click)="navigateToPage('/documenti')"
      >
        <div class="title-container">
          <img src="assets/imgs/icons/documenti.svg" alt="document" />
          <span>Documenti</span>
        </div>
      </section>

      <!-- Invoice Container -->
      <section class="invoice-container" [style]="getCardAnimationDelay(3)">
        <div class="card-flip">
          <div
            class="card-front clickable"
            (click)="navigateToPage('/fatture')"
          >
            <div class="title-container">
              <img src="assets/imgs/icons/fatture.svg" alt="invoice" />
              <span>Fatture</span>
            </div>
            <div class="feature-list invoice-features">
              <div class="feature-item">
                <mat-icon>receipt_long</mat-icon>
                <span>Elenco Fatture</span>
              </div>
              <div class="feature-item">
                <mat-icon>list</mat-icon>
                <span>Elenco Clienti</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- AI Analysis Section -->
      <section class="ai-analysis-section" [style]="getCardAnimationDelay(4)">
        <div class="card-flip">
          <div
            class="card-front clickable"
            (click)="navigateToPage('/analisi-ai')"
          >
            <div class="title-container">
              <img src="assets/imgs/icons/analisi_ai.svg" alt="ai" />
              <span>Analisi AI</span>
            </div>
            <div class="feature-list">
              <div class="feature-row">
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/speaker_wave.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Trascrizione</span>
                </div>
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/document_minus.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Sintesi Colloquio</span>
                </div>
              </div>
              <div class="feature-row">
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/presentation_chart.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Distribuzione Topic Nucleari</span>
                </div>
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/cloud.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Wordcloud</span>
                </div>
              </div>
              <div class="feature-row">
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/document-chart-bar.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Scheda Clinica Dinamica</span>
                </div>
                <div class="feature-item">
                  <img
                    src="assets/imgs/icons/document_plus.svg"
                    alt="ai"
                    style="height: 30px"
                  />
                  <span>Sintesi Complessiva</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Profile Section -->
      <section class="profile-section" [style]="getCardAnimationDelay(5)">
        <div class="user-info">
          <div class="user-avatar">
            <img
              [src]="profilePicture"
              referrerPolicy="no-referrer"
              alt="avatar"
            />
          </div>
          <span class="name">{{ doctor.first_name }}</span>
          <div class="email">{{ doctor.signin_mail }}</div>
        </div>
        <div class="user-related-actions">
          <div class="actions-group">
            <div class="row">
              <img src="assets/imgs/icons/user_circle.svg" alt="user" />
              <span (click)="navigateToPage('/area-personale')"
                >Area Personale</span
              >
            </div>
            <div class="actions-row">
              <div class="row">
                <img
                  src="assets/imgs/icons/question_mark_circle.svg"
                  alt="user"
                />
                <span (click)="navigateToPage('/faq')">FAQ</span>
              </div>
              <div class="row">
                <img
                  src="assets/imgs/icons/arrow-left-start-on-rectangle.svg"
                  alt="user"
                />
                <span (click)="logout()">Logout</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <!-- Simplified Footer -->
  <footer class="footer-container">
    <div class="footer-content">
      <a (click)="navigateToPage('/informativa-privacy')" class="footer-link">
        Informativa Privacy
      </a>
      <a (click)="navigateToPage('/termini-di-servizio')" class="footer-link">
        Termini di Servizio
      </a>
    </div>
  </footer>
</div>
